import script from "./DataNavList.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataNavList.vue?vue&type=script&setup=true&lang=ts"

import "./DataNavList.vue?vue&type=style&index=0&id=f0ca9a34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0ca9a34"]])

export default __exports__